import React, { useEffect, useState, useRef } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { SlLocationPin } from "react-icons/sl";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import axiosConfig from "../../Service/AxiosConfig";
import { PopupModal } from "../PopupModal/PopupModal";
import { useLocationContext } from "../../context/LocationContext";
import ShowDeleteModal from "../PopupModal/ShowDeleteModal";
import "./ServiceDetails.css";
import { useDispatch } from "react-redux";
import { updateTempForm } from "../../redux/BookingFormSlice";
import { useSelector } from "react-redux";
import { FaChevronDown } from "react-icons/fa";
import Select from "react-select";
const isValidMobile = (v) => /^[6-9]\d{9}$/.test(v);
const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
const FamilyDetails = ({ form, setForm, isLocked }) => {
  const [saving, setSaving] = useState(false);
  const hasFetchedRef = useRef(false);
  const dispatch = useDispatch();
  const [editIndex, setEditIndex] = useState(null);
  const [relationList, setRelationList] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const { location, setLocation, setAddressModalOpen } = useLocationContext();
  const [extraFamilies, setExtraFamilies] = useState([]);
  const [popupType, setPopupType] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState({});
  const [mobileError, setMobileError] = useState({});
  const [emailError, setEmailError] = useState({});
  const [addressError, setAddressError] = useState("");
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const tempData = useSelector((state) => state.bookingForm.tempData);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const firstFieldRef = useRef(null);
  const hasFocusedOnce = useRef(false);
  const moreFamilyRef = useRef(null);
  const canAddAlternate = !!form?.family_id && editIndex === null && !saving;
  const isMainFamilySaved = Boolean(form?.family_id);
  const relationOptions = relationList.map((r) => ({
    value: r.id,
    label: r.name,
  }));

  const fieldsToCheck = [
    "family_champion",
    "relation",
    "mobile_number",
    "email",
    "address",
  ];

  useEffect(() => {
    axiosConfig
      .get("/masters/relations/?is_suspended=false")
      .then((res) => setRelationList(res.data.results || []))
      .catch(console.error);
  }, []);

  useEffect(() => {
    if (!location.address) return;
    setForm((prev) => ({
      ...prev,
      address: location.address,
      latitude: Number(location.latitude),
      longitude: Number(location.longitude),
      address_id: location.address_id,
    }));
  }, [location.address, location.address_id, location.source]);

  const fetchFamilyDetails = async (leadId) => {
    try {
      const res = await axiosConfig.get(
        `/accounts/family-details/?lead=${leadId}`,
      );
      const list = res?.data?.results || [];
      if (!list.length) return;
      const main = list[0];
      setForm((prev) => ({
        ...prev,
        family_champion: main.family_champion || "",
        relation: main.relation || "",
        mobile_number: main.mobile_number || "",
        email: main.email || "",
        address: main.address || "",
        address_id: main.address_id || null,
        latitude: main.latitude || null,
        longitude: main.longitude || null,
        family_id: main?.id,
      }));
      setExtraFamilies(
        list.slice(1).map((f) => ({
          family_champion: f.family_champion || "",
          relation: f.relation || "",
          mobile_number: f.mobile_number || "",
          email: f.email || "",
          family_id: f?.id,
        })),
      );
    } catch (err) {
      console.error("Error fetching family details", err);
    }
  };
  useEffect(() => {
    if (editIndex === null) {
      setMobileError({});
      setEmailError({});
      setAddressError("");
    }
  }, [editIndex]);

  const hasAnyData =
    fieldsToCheck.some((k) => form?.[k] && String(form[k]).trim() !== "") ||
    extraFamilies.some((f) =>
      ["family_champion", "relation", "mobile_number", "email"].some(
        (k) => f?.[k] && String(f[k]).trim() !== "",
      ),
    );

  useEffect(() => {
    if (!expanded) return;
    const isApiDataEmpty = fieldsToCheck.every(
      (key) => !form?.[key] || String(form[key]).trim() === "",
    );
    if ((isApiDataEmpty || !hasFocusedOnce.current) && firstFieldRef.current) {
      setTimeout(() => {
        firstFieldRef.current.focus();
        hasFocusedOnce.current = true;
      }, 0);
    }
  }, [expanded, form]);

  useEffect(() => {
    if (!form?.booking_id) return;

    const saved = tempData?.[form.booking_id];

    if (Array.isArray(saved?.family_details)) {
      setExtraFamilies(saved.family_details);
    }
  }, [form?.booking_id, tempData]);

  useEffect(() => {
    const leadId = form?.lead?.id || form?.lead_id;
    if (!leadId || hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchFamilyDetails(leadId);
  }, [form?.lead?.id, form?.lead_id]);
  useEffect(() => {
    if (form.address_id) {
      setAddressError("");
    }
  }, [form.address_id]);

  if (!form) return null;
  const addFamilyRow = () => {
    const updated = [
      ...extraFamilies,
      {
        family_champion: "",
        relation: "",
        mobile_number: "",
        email: "",
        family_id: null,
      },
    ];

    const newIndex = updated.length - 1;

    setExtraFamilies(updated);
    setEditIndex(newIndex);
    setIsDirty(true);

    dispatch(
      updateTempForm({
        booking_id: form.booking_id,
        data: { family_details: updated },
      }),
    );

    setTimeout(() => moreFamilyRef.current?.focus(), 0);
  };

  const updateExtraField = (index, field, value) => {
    setIsDirty(true);

    const updated = extraFamilies.map((f, i) =>
      i === index ? { ...f, [field]: value } : f,
    );

    setExtraFamilies(updated);

    dispatch(
      updateTempForm({
        booking_id: form.booking_id,
        data: { family_details: updated },
      }),
    );
  };

  const updateFormAndRedux = (field, value) => {
    setIsDirty(true);

    setForm((prev) => ({ ...prev, [field]: value }));

    dispatch(
      updateTempForm({
        booking_id: form.booking_id,
        data: { [field]: value },
      }),
    );
  };
 
  const confirmDeleteFamily = async () => {
    setSaving(true);
    try {
      if (!deleteId) {
        setExtraFamilies((prev) => prev.filter((_, i) => i !== deleteIndex));
        setEditIndex(null);
        setIsDirty(false);
        setPopupType("success");
        setMessage("Alternate contact removed");
        return;
      }

      await axiosConfig.delete(`/accounts/family-details/${deleteId}/`);
      setExtraFamilies((prev) => prev.filter((s) => s.family_id !== deleteId));
      setEditIndex(null);
      setPopupType("success");
      setMessage("Family deleted successfully");
    } catch (err) {
      setPopupType("error");
      setError("Failed to delete family");
    } finally {
      setShowDeletePopup(false);
      setDeleteId(null);
      setDeleteIndex(null);
      setSaving(false);
    }
  };

  const handleSaveMainFamily = async () => {
    if (saving) return;
    setSaving(true);

    setMobileError({});
    setEmailError({});
    setAddressError("");
    setError("");

    const leadId = form.lead?.id || form.lead_id;
    if (!leadId) {
      setSaving(false);
      return;
    }

    if (!form.mobile_number) {
      setMobileError({ main: "Mobile number is required" });
      setSaving(false);
      return;
    }

    if (!isValidMobile(form.mobile_number)) {
      setMobileError({ main: "Enter valid 10-digit mobile number" });
      setSaving(false);
      return;
    }

    if (form.email && !isValidEmail(form.email)) {
      setEmailError({ main: "Invalid email address" });
      setSaving(false);
      return;
    }

    const payload = [
      {
        family_id: form.family_id,
        lead: leadId,
        family_champion: form.family_champion,
        relation: form.relation || null,
        mobile_number: form.mobile_number,
        email: form.email || "",
        address: form.address,
        address_id: form.address_id,
        latitude: form.latitude,
        longitude: form.longitude,
      },
    ];

    try {
      await axiosConfig.patch(
        "/accounts/family-details/bulk-update/",
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      setPopupType("success");
      setMessage("Family Details Saved Successfully");

      setEditIndex(null);
      setIsDirty(false);
      setExpanded(false);

      fetchFamilyDetails(leadId);
    } catch (err) {
      setPopupType("error");
      setError("Failed to save main family details");
    } finally {
      setSaving(false);
    }
  };
  const handleSaveExtraFamily = async (index) => {
    if (saving) return;
    setSaving(true);

    setMobileError({});
    setEmailError({});
    setError("");

    const leadId = form.lead?.id || form.lead_id;
    if (!leadId) {
      setSaving(false);
      return;
    }

    const f = extraFamilies[index];

    if (!f.mobile_number) {
      setMobileError({ [index]: "Mobile number is required" });
      setSaving(false);
      return;
    }

    if (!isValidMobile(f.mobile_number)) {
      setMobileError({ [index]: "Enter valid 10-digit mobile number" });
      setSaving(false);
      return;
    }

    if (f.email && !isValidEmail(f.email)) {
      setEmailError({ [index]: "Invalid email address" });
      setSaving(false);
      return;
    }

    const payload = [
      {
        family_id: f.family_id,
        lead: leadId,
        family_champion: f.family_champion,
        relation: f.relation || null,
        mobile_number: f.mobile_number,
        email: f.email || "",
      },
    ];

    try {
      await axiosConfig.patch(
        "/accounts/family-details/bulk-update/",
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      setPopupType("success");
      setMessage("Alternate Contact Saved Successfully");

      setEditIndex(null);
      setIsDirty(false);

      fetchFamilyDetails(leadId);
    } catch (err) {
      setPopupType("error");
      setError("Failed to save alternate contact");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Accordion
        key={expanded ? "open" : "closed"}
        allowZeroExpanded
        preExpanded={expanded ? ["patient"] : []}
        onChange={(uuids) => {
          setExpanded(uuids.includes("patient"));
        }}
      >
        <AccordionItem uuid="patient">
          <AccordionItemHeading>
            <AccordionItemButton className="bd-header">
              <h4 className="bd-title">Family Details</h4>
              <span className="bd-add-btn">
                Add Details
                <FaChevronDown
                  style={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                    marginLeft: "5px",
                  }}
                />
              </span>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="bd-panel">
            <div
              className={`bd-section-grid bd-grid-3 service-cards ${
                isLocked ? "locked-section" : ""
              }`}
            >
              <div className="form-group">
                <label
                  className={`form-label ${editIndex !== -1 ? "view-mode-label" : ""}`}
                >
                  Family Champion
                </label>
                <input
                  name="family_champion"
                  type="text"
                  ref={firstFieldRef}
                  placeholder="Family Champion"
                  value={form.family_champion || ""}
                  className={`form-control ${editIndex !== -1 ? "view-mode-text" : ""}`}
                  onChange={(e) =>
                    updateFormAndRedux("family_champion", e.target.value)
                  }
                  disabled={(isMainFamilySaved && editIndex !== -1) || isLocked}
                />
              </div>

              <div className="form-group">
                <label
                  className={`form-label ${editIndex !== -1 ? "view-mode-label" : ""}`}
                >
                  Relation
                </label>

                <Select
                  options={relationOptions}
                  value={
                    relationOptions.find(
                      (opt) => opt.value === form?.relation,
                    ) || null
                  }
                  onChange={(selected) => {
                    if (!selected) return;

                    setEditIndex(-1);
                    setIsDirty(true);

                    updateFormAndRedux("relation", selected.value);
                  }}
                  isDisabled={
                    (isMainFamilySaved && editIndex !== -1) || isLocked
                  }
                  placeholder="Select Relation"
                  isSearchable={false}
                  classNamePrefix="height-select"
                  className={editIndex !== -1 ? "view-mode-text" : ""}
                />
              </div>

              <div className="form-group">
                <label
                  className={`form-label ${editIndex !== -1 ? "view-mode-label" : ""}`}
                >
                  Mobile Number
                </label>
                <sup style={{ color: "red" }}>*</sup>
                <input
                  type="text"
                  placeholder="Mobile Number"
                  name="mobile_number"
                  maxLength={10}
                  className={`form-control ${editIndex !== -1 ? "view-mode-text" : ""}`}
                  value={form.mobile_number || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (!/^\d*$/.test(value)) return;
                    if (value.length > 10) return;
                    updateFormAndRedux("mobile_number", value);
                    if (value.length !== 10) {
                      setMobileError((p) => ({
                        ...p,
                        main: "Mobile number must be 10 digits",
                      }));
                    } else {
                      setMobileError((p) => ({ ...p, main: "" }));
                    }
                  }}
                  disabled={(isMainFamilySaved && editIndex !== -1) || isLocked}
                />

                {mobileError.main && (
                  <small style={{ color: "red", fontSize: "12px" }}>
                    {mobileError.main}
                  </small>
                )}
              </div>

              <div className="form-group">
                <label
                  className={`form-label ${editIndex !== -1 ? "view-mode-label" : ""}`}
                >
                  Email
                </label>
                <input
                  type="email"
                  placeholder="Email"
                  className={`form-control ${editIndex !== -1 ? "view-mode-text" : ""}`}
                  name="email"
                  value={form?.email || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    updateFormAndRedux("email", value);

                    if (value && !isValidEmail(value)) {
                      setEmailError((p) => ({
                        ...p,
                        main: "Invalid email address",
                      }));
                    } else {
                      setEmailError((p) => ({ ...p, main: "" }));
                    }
                  }}
                  disabled={(isMainFamilySaved && editIndex !== -1) || isLocked}
                />
                {emailError.main && (
                  <small style={{ color: "red", fontSize: "12px" }}>
                    {emailError.main}
                  </small>
                )}
              </div>
              <div className="form-group full-width">
                <label
                  className={`form-label ${editIndex !== -1 ? "view-mode-label" : ""}`}
                >
                  Address
                </label>
                <div className="bd-address-container">
                  <input
                    className={`${editIndex !== -1 ? "view-mode-label" : ""}`}
                    value={form.address || ""}
                    placeholder="Address"
                    style={{ padding: "10px" }}
                    readOnly
                    onFocus={() => {
                      if (!form.address_id) {
                        setAddressError("Please choose address using map");
                      }
                    }}
                    onKeyDown={(e) => {
                      e.preventDefault();
                      if (!form.address_id) {
                        setAddressError("Please choose address using map");
                      }
                    }}
                  />

                  <button
                    className="bd-choose-map-btn"
                    disabled={
                      (isMainFamilySaved && editIndex !== -1) || isLocked
                    }
                    onClick={() => {
                      setLocation({
                        address: form.address || "",
                        latitude: Number(form.latitude) || null,
                        longitude: Number(form.longitude) || null,
                        address_id: form.address_id || null,
                        source: "Website",
                      });

                      setAddressModalOpen(true);
                    }}
                  >
                    <SlLocationPin size={16} /> Choose Map
                  </button>
                </div>
                {addressError && <p className="error-text">{addressError}</p>}
              </div>

              <div className="form-group full-width">
                <div className="bd-actions">
                  {(!isMainFamilySaved || (editIndex === -1 && !isLocked)) && (
                    <button
                      className="bd-save-btn"
                      onClick={handleSaveMainFamily}
                      disabled={saving}
                    >
                      Save
                    </button>
                  )}
                  {isMainFamilySaved && editIndex !== -1 && (
                    <button
                      className="bd-edit-btn"
                      onClick={() => {
                        setEditIndex(-1);
                        setIsDirty(true);
                        setExpanded(true);
                      }}
                    >
                      Edit
                    </button>
                  )}
                </div>
              </div>
            </div>

            {extraFamilies.map((item, index) => (
              <div
                key={index}
                className={`bd-section-grid bd-grid-3 service-cards${
                  isLocked ? "locked-section" : ""
                }`}
              >
                {editIndex === index && (
                  <button
                    className="delete-service-btn"
                    onClick={() => {
                      setDeleteId(extraFamilies[index]?.family_id || null);
                      setDeleteIndex(index);
                      setShowDeletePopup(true);
                    }}
                  >
                    <FaTrashAlt size={14} />
                  </button>
                )}

                <div className="form-group">
                  <label
                    className={`form-label ${editIndex !== index ? "view-mode-label" : ""}`}
                  >
                    Family Champion
                  </label>
                  <input
                    ref={moreFamilyRef}
                    name="family_champion"
                    type="text"
                    placeholder="Family Champion"
                    value={item.family_champion}
                    className={`form-control ${editIndex !== index ? "view-mode-text" : ""}`}
                    onChange={(e) =>
                      updateExtraField(index, "family_champion", e.target.value)
                    }
                    disabled={editIndex !== index || isLocked}
                  />
                </div>

                <div className="form-group">
                  <label
                    className={`form-label ${editIndex !== index ? "view-mode-label" : ""}`}
                  >
                    Relation
                  </label>
                  <Select
                    options={relationOptions}
                    value={
                      relationOptions.find(
                        (opt) => opt.value === item?.relation,
                      ) || null
                    }
                    onChange={(selected) => {
                      if (!selected) return;
                      setEditIndex(index);
                      setIsDirty(true);
                      updateExtraField(index, "relation", selected.value);
                    }}
                    isDisabled={editIndex !== index || isLocked}
                    placeholder="Select Relation"
                    isSearchable={false}
                    classNamePrefix="height-select"
                    className={editIndex !== index ? "view-mode-text" : ""}
                  />
                </div>

                <div className="form-group">
                  <label
                    className={`form-label ${editIndex !== index ? "view-mode-label" : ""}`}
                  >
                    Mobile Number
                  </label>
                  <sup style={{ color: "red" }}>*</sup>
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    name="mobile_number"
                    maxLength={10}
                    value={item?.mobile_number || ""}
                    className={`form-control ${editIndex !== index ? "view-mode-text" : ""}`}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!/^\d*$/.test(value)) return;
                      if (value.length > 10) return;
                      updateExtraField(index, "mobile_number", value);
                      if (value.length !== 10) {
                        setMobileError((p) => ({
                          ...p,
                          [index]: "Mobile number must be 10 digits",
                        }));
                      } else {
                        setMobileError((p) => ({ ...p, [index]: "" }));
                      }
                    }}
                    disabled={editIndex !== index || isLocked}
                  />

                  {mobileError[index] && (
                    <small style={{ color: "red", fontSize: "12px" }}>
                      {mobileError[index]}
                    </small>
                  )}
                </div>

                <div className="form-group">
                  <label
                    className={`form-label ${editIndex !== index ? "view-mode-label" : ""}`}
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={item?.email}
                    className={`form-control ${editIndex !== index ? "view-mode-text" : ""}`}
                    onChange={(e) => {
                      const value = e.target.value;
                      updateExtraField(index, "email", value);

                      if (value && !isValidEmail(value)) {
                        setEmailError((p) => ({
                          ...p,
                          [index]: "Invalid email address",
                        }));
                      } else {
                        setEmailError((p) => ({ ...p, [index]: "" }));
                      }
                    }}
                    disabled={editIndex !== index || isLocked}
                  />
                  {emailError[index] && (
                    <small style={{ color: "red", fontSize: "12px" }}>
                      {emailError[index]}
                    </small>
                  )}
                </div>
                <div className="form-group full-width">
                  <div className="bd-actions">
                    {!isLocked && editIndex !== index ? (
                      <button
                        className="bd-edit-btn"
                        onClick={() => {
                          setEditIndex(index);
                          setIsDirty(true);
                          setExpanded(true);
                        }}
                      >
                        Edit
                      </button>
                    ) : (
                      !isLocked &&
                      hasAnyData &&
                      editIndex === index && (
                        <button
                          className="bd-save-btn"
                          onClick={() => handleSaveExtraFamily(index)}
                          disabled={saving}
                        >
                          Save
                        </button>
                      )
                    )}
                  </div>
                </div>
              </div>
            ))}

            {canAddAlternate && !isLocked && (
              <button className="add-btn" onClick={addFamilyRow}>
                <FaPlus /> Add Alternate Contact
              </button>
            )}
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
      {showDeletePopup && (
        <ShowDeleteModal
          open={showDeletePopup}
          onConfirm={confirmDeleteFamily}
          onCancel={() => setShowDeletePopup(false)}
        />
      )}
      {popupType && (
        <PopupModal
          setpopupType={setPopupType}
          popupType={popupType}
          error={error}
          Message={message}
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export default FamilyDetails;
